import { render } from "./FAQSubsection.vue?vue&type=template&id=3d8b4acf&ts=true"
import script from "./FAQSubsection.vue?vue&type=script&lang=ts"
export * from "./FAQSubsection.vue?vue&type=script&lang=ts"

import "./FAQSubsection.vue?vue&type=style&index=0&id=3d8b4acf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__